import { ReactNode } from "react";

type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
};

export function EmptyState({ title, description, icon }: EmptyStateProps) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-600 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
      {icon ? <div className="text-slate-500 dark:text-slate-400">{icon}</div> : null}
      <div className="space-y-1">
        <p className="font-semibold text-slate-800 dark:text-slate-100">{title}</p>
        {description ? <p className="text-slate-600 dark:text-slate-300">{description}</p> : null}
      </div>
    </div>
  );
}
